import { Navigate, Outlet, Link } from "react-router-dom";
import { LoginForm } from "../components/LoginForm";
import  Footer from "../components/Footer";
// import { useAuth } from "../hooks/useAuth";
import { useLocalStorage } from "../hooks/useLocalStorage";

const Home = () => {
    // const { user } = useAuth();
    const [user, setUser] = useLocalStorage("user", null);

    if (user) {
        return <Navigate to="/dashboard" />;
    }

    return (
        <div id="Home" className="flex flex-col justify-between h-screen">
            <LoginForm />  
            <Footer />          
        </div>

    )
};

export default Home;